export const SHIPPING_PROVIDERS_RESET_STATE = 'SHIPPING_PROVIDERS_RESET_STATE';
export const SHIPPING_PROVIDERS_CURRENT_ITEM = 'SHIPPING_PROVIDERS_CURRENT_ITEM';

export const SHIPPING_PROVIDERS_REQUEST_LOADING = 'SHIPPING_PROVIDERS_REQUEST_LOADING';
export const SHIPPING_PROVIDERS_REQUEST_SUCCESS = 'SHIPPING_PROVIDERS_REQUEST_SUCCESS';
export const SHIPPING_PROVIDERS_REQUEST_FAILED = 'SHIPPING_PROVIDERS_REQUEST_FAILED';

export const SHIPPING_PROVIDERS_CURRENT_ACTION = 'SHIPPING_PROVIDERS_CURRENT_ACTION';
export const SHIPPING_PROVIDERS_RESET_ACTION = 'SHIPPING_PROVIDERS_RESET_ACTION';